import { EventBus } from "@/event-bus.js";
class Helper {
    validateSection(state, sectionFour, sectionSix, sectionSeven) {
        // console.log("section1, section2, any", sectionFour, sectionSeven)
        // console.log("calling validateSection Helper --------------- ")
        let foundScore = undefined,
            groupCountr = undefined,
            eleNewCombo = undefined;


        let foundCombo = sectionSix.formElements.find(
            (a) => a.inputType == "comboSelectProgressive"
        );
        // console.log("foundCombo", foundCombo)

        eleNewCombo = state.userFormSubmitArray.find(
            (ele) => ele.elementId == foundCombo.id
        );

        // console.log("eleNewCombo", eleNewCombo.elements)

        if (eleNewCombo && eleNewCombo.elements) {
            groupCountr = eleNewCombo.elements.find(
                (ctr) => ctr.score == 16
            );
            // console.log("groupCountr", groupCountr)
        }

        let eleNew = state.userFormSubmitArray.find(
            (ele) => ele.elementId == sectionFour.formElements[0].id
        );



        if (eleNew && eleNew.elements.length) {
            foundScore = eleNew.elements.find(
                (ele) => ele.score == 13
            );
            // console.log("foundScore")
        }
        // console.log("foundScore", foundScore)
        // console.log("groupCountr", groupCountr)

        if (groupCountr && foundScore) {
            console.log("is Hidden false Helper validate helper");
            let sec = state.form1.formSection[sectionSeven.index];
            Object.assign(sec, (sec.isHidden = false));
            EventBus.$emit(
                "sectionCheck",
                state.form1.formSection[sectionSeven.index]
            );
            state.form1.formSection[sectionSeven.index].formElements.map(
                (ele) => {
                    // ele.validation.required = 1;
                    // ele.isInValid = true;
                }
            );
        } else {
            console.log("is Hidden true helper validate helper");
            let sec = state.form1.formSection[sectionSeven.index];
            Object.assign(sec, (sec.isHidden = true));
            EventBus.$emit(
                "sectionCheck",
                state.form1.formSection[sectionSeven.index]
            );
            

            state.form1.formSection[sectionSeven.index].formElements.map(
                (ele) => {
                    ele.validation.required = 0;
                    ele.isInValid = false;
                   let foundEle = state.userFormSubmitArray.find(
                        (ele1) => ele1.elementId == ele.id
                    );
                    // console.log("eeeee", foundEle)
                    if(foundEle){
                        foundEle.elements = []
                    }
                }
            );
            // this.form1.formSection[sectionFour.index].isHidden = false;
        }
    }
}
export default new Helper();